import { useNuxtApp, useRequestEvent } from "nuxt/app";
export function updateSiteConfig(input = {}) {
  const stack = import.meta.server ? useRequestEvent()?.context.siteConfig : useNuxtApp().$nuxtSiteConfig;
  return stack.push(input);
}
